/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { CarrierChequeInformation } from "./CarrierChequeInformation";
import {
  CarrierChequeInformationFromJSON,
  CarrierChequeInformationFromJSONTyped,
  CarrierChequeInformationToJSON,
  CarrierChequeInformationToJSONTyped,
} from "./CarrierChequeInformation";
import type { CarrierPaymentStrategy } from "./CarrierPaymentStrategy";
import {
  CarrierPaymentStrategyFromJSON,
  CarrierPaymentStrategyFromJSONTyped,
  CarrierPaymentStrategyToJSON,
  CarrierPaymentStrategyToJSONTyped,
} from "./CarrierPaymentStrategy";
import type { MissingInvoiceStrategy } from "./MissingInvoiceStrategy";
import {
  MissingInvoiceStrategyFromJSON,
  MissingInvoiceStrategyFromJSONTyped,
  MissingInvoiceStrategyToJSON,
  MissingInvoiceStrategyToJSONTyped,
} from "./MissingInvoiceStrategy";

/**
 *
 * @export
 * @interface CarrierPaymentProperties
 */
export interface CarrierPaymentProperties {
  /**
   *
   * @type {string}
   * @memberof CarrierPaymentProperties
   */
  manualPaymentProcessingInstructions: string;
  /**
   *
   * @type {CarrierPaymentStrategy}
   * @memberof CarrierPaymentProperties
   */
  invoicePaymentStrategy: CarrierPaymentStrategy;
  /**
   *
   * @type {MissingInvoiceStrategy}
   * @memberof CarrierPaymentProperties
   */
  missingInvoiceStrategy: MissingInvoiceStrategy;
  /**
   *
   * @type {number}
   * @memberof CarrierPaymentProperties
   */
  daysToWaitSincePickupBeforePayingInvoices: number;
  /**
   *
   * @type {number}
   * @memberof CarrierPaymentProperties
   */
  daysToWaitSinceDeliveryBeforePayingInvoices: number;
  /**
   *
   * @type {boolean}
   * @memberof CarrierPaymentProperties
   */
  chargesTaxesOnInvoices: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CarrierPaymentProperties
   */
  chargesTaxesOnQuotes: boolean;
  /**
   *
   * @type {string}
   * @memberof CarrierPaymentProperties
   */
  xeroContactId: string;
  /**
   *
   * @type {boolean}
   * @memberof CarrierPaymentProperties
   */
  sendRemittanceAdvice: boolean;
  /**
   *
   * @type {string}
   * @memberof CarrierPaymentProperties
   */
  remitttanceAdviceAdditionalText?: string | null;
  /**
   *
   * @type {CarrierChequeInformation}
   * @memberof CarrierPaymentProperties
   */
  chequeInformationCad?: CarrierChequeInformation | null;
  /**
   *
   * @type {CarrierChequeInformation}
   * @memberof CarrierPaymentProperties
   */
  chequeInformationUsd?: CarrierChequeInformation | null;
  /**
   *
   * @type {Array<CurrencyCode>}
   * @memberof CarrierPaymentProperties
   */
  allowedCurrencyCodes: Array<CurrencyCode>;
  /**
   *
   * @type {string}
   * @memberof CarrierPaymentProperties
   */
  billToAddress: string;
  /**
   *
   * @type {number}
   * @memberof CarrierPaymentProperties
   */
  invoiceAuditRequiresPingNumberOfDays: number;
}

/**
 * Check if a given object implements the CarrierPaymentProperties interface.
 */
export function instanceOfCarrierPaymentProperties(
  value: object,
): value is CarrierPaymentProperties {
  if (
    !("manualPaymentProcessingInstructions" in value) ||
    value["manualPaymentProcessingInstructions"] === undefined
  )
    return false;
  if (
    !("invoicePaymentStrategy" in value) ||
    value["invoicePaymentStrategy"] === undefined
  )
    return false;
  if (
    !("missingInvoiceStrategy" in value) ||
    value["missingInvoiceStrategy"] === undefined
  )
    return false;
  if (
    !("daysToWaitSincePickupBeforePayingInvoices" in value) ||
    value["daysToWaitSincePickupBeforePayingInvoices"] === undefined
  )
    return false;
  if (
    !("daysToWaitSinceDeliveryBeforePayingInvoices" in value) ||
    value["daysToWaitSinceDeliveryBeforePayingInvoices"] === undefined
  )
    return false;
  if (
    !("chargesTaxesOnInvoices" in value) ||
    value["chargesTaxesOnInvoices"] === undefined
  )
    return false;
  if (
    !("chargesTaxesOnQuotes" in value) ||
    value["chargesTaxesOnQuotes"] === undefined
  )
    return false;
  if (!("xeroContactId" in value) || value["xeroContactId"] === undefined)
    return false;
  if (
    !("sendRemittanceAdvice" in value) ||
    value["sendRemittanceAdvice"] === undefined
  )
    return false;
  if (
    !("allowedCurrencyCodes" in value) ||
    value["allowedCurrencyCodes"] === undefined
  )
    return false;
  if (!("billToAddress" in value) || value["billToAddress"] === undefined)
    return false;
  if (
    !("invoiceAuditRequiresPingNumberOfDays" in value) ||
    value["invoiceAuditRequiresPingNumberOfDays"] === undefined
  )
    return false;
  return true;
}

export function CarrierPaymentPropertiesFromJSON(
  json: any,
): CarrierPaymentProperties {
  return CarrierPaymentPropertiesFromJSONTyped(json, false);
}

export function CarrierPaymentPropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierPaymentProperties {
  if (json == null) {
    return json;
  }
  return {
    manualPaymentProcessingInstructions:
      json["manualPaymentProcessingInstructions"],
    invoicePaymentStrategy: CarrierPaymentStrategyFromJSON(
      json["invoicePaymentStrategy"],
    ),
    missingInvoiceStrategy: MissingInvoiceStrategyFromJSON(
      json["missingInvoiceStrategy"],
    ),
    daysToWaitSincePickupBeforePayingInvoices:
      json["daysToWaitSincePickupBeforePayingInvoices"],
    daysToWaitSinceDeliveryBeforePayingInvoices:
      json["daysToWaitSinceDeliveryBeforePayingInvoices"],
    chargesTaxesOnInvoices: json["chargesTaxesOnInvoices"],
    chargesTaxesOnQuotes: json["chargesTaxesOnQuotes"],
    xeroContactId: json["xeroContactId"],
    sendRemittanceAdvice: json["sendRemittanceAdvice"],
    remitttanceAdviceAdditionalText:
      json["remitttanceAdviceAdditionalText"] == null
        ? undefined
        : json["remitttanceAdviceAdditionalText"],
    chequeInformationCad:
      json["chequeInformationCad"] == null
        ? undefined
        : CarrierChequeInformationFromJSON(json["chequeInformationCad"]),
    chequeInformationUsd:
      json["chequeInformationUsd"] == null
        ? undefined
        : CarrierChequeInformationFromJSON(json["chequeInformationUsd"]),
    allowedCurrencyCodes: (json["allowedCurrencyCodes"] as Array<any>).map(
      CurrencyCodeFromJSON,
    ),
    billToAddress: json["billToAddress"],
    invoiceAuditRequiresPingNumberOfDays:
      json["invoiceAuditRequiresPingNumberOfDays"],
  };
}

export function CarrierPaymentPropertiesToJSON(
  json: any,
): CarrierPaymentProperties {
  return CarrierPaymentPropertiesToJSONTyped(json, false);
}

export function CarrierPaymentPropertiesToJSONTyped(
  value?: CarrierPaymentProperties | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    manualPaymentProcessingInstructions:
      value["manualPaymentProcessingInstructions"],
    invoicePaymentStrategy: CarrierPaymentStrategyToJSON(
      value["invoicePaymentStrategy"],
    ),
    missingInvoiceStrategy: MissingInvoiceStrategyToJSON(
      value["missingInvoiceStrategy"],
    ),
    daysToWaitSincePickupBeforePayingInvoices:
      value["daysToWaitSincePickupBeforePayingInvoices"],
    daysToWaitSinceDeliveryBeforePayingInvoices:
      value["daysToWaitSinceDeliveryBeforePayingInvoices"],
    chargesTaxesOnInvoices: value["chargesTaxesOnInvoices"],
    chargesTaxesOnQuotes: value["chargesTaxesOnQuotes"],
    xeroContactId: value["xeroContactId"],
    sendRemittanceAdvice: value["sendRemittanceAdvice"],
    remitttanceAdviceAdditionalText: value["remitttanceAdviceAdditionalText"],
    chequeInformationCad: CarrierChequeInformationToJSON(
      value["chequeInformationCad"],
    ),
    chequeInformationUsd: CarrierChequeInformationToJSON(
      value["chequeInformationUsd"],
    ),
    allowedCurrencyCodes: (value["allowedCurrencyCodes"] as Array<any>).map(
      CurrencyCodeToJSON,
    ),
    billToAddress: value["billToAddress"],
    invoiceAuditRequiresPingNumberOfDays:
      value["invoiceAuditRequiresPingNumberOfDays"],
  };
}
